
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GridColumn } from '@/models/GridColumn.model';
import { MenuAction } from '@/models/MenuAction.model';
import { Grid } from '@/models/Grid.model';
import { FieldType, SearchFieldModel } from '@/models/SearchField.model';
import { RowAction } from '@/models/RowAction.model';

@Component({})
export default class NewDataSearchWidget extends Vue {

  @Prop()
  public requestorCallback!: any;

  @Prop(Array)
  public serverErrorMessages!: string[];

  @Prop(Array)
  public searchFields!: SearchFieldModel[];

  @Prop(Array)
  public columns!: GridColumn[];

  @Prop(Array)
  public dataTableMenuActions!: MenuAction[];

  @Prop(Array)
  public rowMenuActions!: MenuAction[];

  @Prop(Array)
  public rowActions!: RowAction[];

  @Prop({ type: Object as () => Grid })
  public tableData!: Grid;

  @Prop(String)
  public title!: string;

  @Prop(String)
  public dataTableTitle!: string;

  @Prop(String)
  public searchHeaderTitle!: string;

  @Prop(String)
  public buttonText!: string;

  @Prop(String)
  public submitButtonClasses!: string;

  @Prop(String)
  public cancelBtnClass!: string;

  @Prop(String)
  public dataTableMenuText!: string;

  @Prop(String)
  public hideRowCheckboxProperty!: string;

  @Prop(Boolean)
  public hideTopRowMenuActions!: boolean;

  @Prop(Boolean)
  public loadingProp!: boolean;

  @Prop(Boolean)
  public showCancelBtn!: boolean;

  @Prop(String)
  public cancelBtnText!: string;

  @Prop(Boolean)
  public allCheckboxColumn!: boolean;

  @Prop(Boolean)
  public noPagination!: boolean;

  @Prop(Boolean)
  public showResultTitle3!: boolean;

  @Prop(Boolean)
  public clientPagination!: boolean;

  @Prop({ type: String, default: 'column' }) public formDirection!: string;

  @Prop({ type: Number, default: 10 })
  private pageSize!: number;

  private readonly INIT_PAGE_NUMBER: number = 0;
  private readonly DEFAULT_PAGE_SIZE: number = 10;
  private FieldType = FieldType;
  private searchObject: any = {};
  private showAdvanced: boolean = false;
  private serverErrors: string[] = [];
  private clearSearchFilters: boolean = false;
  private searching: boolean = false;
  private dataTableTitleStr: string = '';

  protected mounted() {
    this.dataTableTitleStr = this.dataTableTitle || this.title;
    if (this.requestorCallback) {
      this.requestorCallback.$on('fetchSearch', this.fetchSearch);
    }
    this.$root.$on('fetchSearch', this.fetchSearch);
    if (this.serverErrorMessages) {
      this.serverErrors = this.serverErrorMessages;
    }
    this.initSearchObject();
  }

  @Watch('serverErrorMessages')
  protected onServerErrorMessagesChanged(newVal: any, oldVal: any) {
    this.serverErrors = this.serverErrorMessages;
  }

  @Watch('pageSize')
  protected onPageSizeChanged() {
    this.searchObject.pageSize = this.pageSize;
  }

  protected initSearchObject(): void {
    this.searchObject = {
      pageNumber: this.INIT_PAGE_NUMBER,
      pageSize: this.pageSize || this.DEFAULT_PAGE_SIZE,
    };
  }

  protected onSearch(page: number): void {
    this.serverErrors = [];
    this.searchObject.pageNumber = page || 0;
    this.searchObject.pageSize = this.searchObject.pageSize || this.pageSize || this.DEFAULT_PAGE_SIZE;
    this.$emit('onSearch', this.searchObject);
    this.searching = this.searchObject.pageNumber === 0;
    setTimeout(() => {
      this.searching = false;
    });
  }

  protected onClear(): void {
    this.serverErrors = [];
    this.clearSearchFilters = true;
    this.initSearchObject();
    this.$emit('onClear', this.searchObject);
    setTimeout(() => { // rerender the search widget in order to refresh its inputs
      this.clearSearchFilters = false;
    });
  }

  protected toggleShowAdvanced(): void {
    this.showAdvanced = !this.showAdvanced;
    if (!this.showAdvanced) {
      this.searchFields.forEach((searchField: SearchFieldModel) => {
        if (searchField.advancedOnly) {
          delete this.searchObject[searchField.property];
        }
      });
    }
  }

  protected onRowClicked(item: any) {
    this.$emit('onRowClicked', item);
  }

  protected onRowActionClicked(action, selectedRows) {
    this.$emit('onRowActionClicked', action, selectedRows);
  }

  protected onTdClicked(item: any, row: any) {
    this.$emit('onTdClicked', item, row);
  }

  protected onTooltipClicked() {
    this.$emit('onTooltipClicked');
  }

  protected updateSelectData(item: any, row: SearchFieldModel) {
    if (row.subFields) {
      for (const field of row.subFields) {
        this.searchObject[field] = null;
      }
    }
    if (row.eventName) {
      this.$emit(row.eventName, item, row);
    }
  }

  protected updateRadioData(item: any, row: SearchFieldModel) {
    if (row.property) {
      this.searchObject[row.property] = item;
      this.$emit('onRadioChanged', item);
    }
  }

  protected onTableHeaderClicked(tableHeader: GridColumn) {
    this.searchObject.sortColumn = tableHeader.sortColumn;
    this.searchObject.sortDirection = tableHeader.sortDirection;
    this.$emit('onSearch', this.searchObject);
  }

  protected onPageChange(page: number) {
    if (this.clientPagination) {
      this.$emit('onPageChange', page);
    } else {
      this.searchObject.pageNumber = page;
      this.onSearch(page - 1);
    }
  }

  protected onRecordsPerPageChanged(records: number) {
    if (this.clientPagination) {
      this.$emit('onRecordsPerPageChanged', records);
    } else {
      this.searchObject.pageSize = records;
      this.onSearch(0);
    }
  }


  private fetchSearch(searchObj: any) {
    setTimeout(() => {
      this.searchObject = searchObj;
      this.onSearch(0);
    });
  }

  private dFlatItemClicked(action: string, result: any) {
    this.$emit('d-flat-item-clicked', action, result);
  }

}
